exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-data-tooltip-container[data-v-c057310e] {\n  border-radius: 5px;\n  border: #333 1px solid;\n  background-color: #eee;\n  padding: 5px;\n}\n", ""]);

// exports
